import React from "react";
import "./AR.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/Foto_About.png";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281287000949&text=Halo%20Antoni,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Asya%20Jakarta%20(About)%20https://marketing-asyajakarta.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="aboutproduk" id="ruko">
      <div className="container-about">
        <h1>Beautiful Life, Beautiful Living</h1>
        <div className="container-desk">
          <div className="desk">
            Asya Jakarta adalah kawasan hunian premium di Jakarta Timur,
            menawarkan perpaduan sempurna antara kenyamanan modern dan keasrian
            alam. Dibangun di atas lahan seluas ±70 hektar di tepi Danau Teluk
            Lestari. Asya menghadirkan lingkungan yang hijau, asri, dan
            eksklusif, lengkap dengan fasilitas kelas dunia dan lokasi yang
            strategis, menjadikan Asya Jakarta pilihan ideal bagi keluarga yang
            mencari hunian berkualitas dengan nilai investasi tinggi.
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#84692a" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Lokasi Strategis di Kawasan Premium
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#84692a" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Akses Mudah ke Tol, Stasiun dan Fasilitas Umum
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#84692a" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Fasilitas Lengkap Kelas Dunia
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#84692a" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Ruang Terbuka Hijau Asri dengan Danau
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#84692a" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Desain Rumah Modern dan Fungsional
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
    </div>
  );
};

export default About;
